/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Campaignservicev1Note } from '../models/Campaignservicev1Note';
import { HttpFile } from '../http/http';

/**
* The event emitted when OrderLine paid is set
*/
export class V1OrderLinePaidSet {
    /**
    * ID of the Order Line.
    */
    'orderLineId'?: string;
    /**
    * ID of the Org.
    */
    'orgId'?: string;
    'paid'?: boolean;
    'requestId'?: string;
    'timestamp'?: Date;
    'userId'?: string;
    'note'?: Campaignservicev1Note;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orderLineId",
            "baseName": "order_line_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "paid",
            "baseName": "paid",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "requestId",
            "baseName": "request_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "note",
            "baseName": "note",
            "type": "Campaignservicev1Note",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLinePaidSet.attributeTypeMap;
    }

    public constructor() {
    }
}

